import styled from 'styled-components';

interface LXTextProps {
  width?: string;
  maxWidth?: string;
  height?: string;
  color?: string;
  textAlign?:
    | 'start'
    | 'end'
    | 'left'
    | 'right'
    | 'center'
    | 'justify'
    | 'match-parent';
  flexGrow?: number;
  flexShrink?: number;
  flexBasis?: string;
  whiteSpace?:
    | 'normal'
    | 'pre'
    | 'nowrap'
    | 'pre-wrap'
    | 'pre-line'
    | 'break-spaces';
  fontWeight?: number;

  overflowWrap?: 'normal' | 'break-word' | 'anywhere';
  alignSelf?:
    | 'auto'
    | 'flex-start'
    | 'flex-end'
    | 'center'
    | 'baseline'
    | 'stretch';
  lineHeight?: string;
  overflow?: 'visible' | 'hidden' | 'scroll' | 'auto' | 'undefined';
  textOverflow?: 'clip' | 'ellipsis' | 'string';
  opacity?: number;
  fontSize?: string;
  hoverEffect?: 'underline' | 'none';
}

export const LXh2 = styled.div<LXTextProps>`
  font-family: 'Outfit';
  font-style: normal;
  font-weight: ${(props) => props.fontWeight ?? 600};
  font-size: 24px;
  line-height: 31px;
  height: ${(props) => props.height ?? '31px'};
  width: ${(props) => props.width};
  max-width: ${(props) => props.maxWidth};
  color: ${(props) => props.color ?? props.theme.colors.title};

  overflow: ${(props) => props.overflow ?? 'hidden'};
  text-overflow: ${(props) => props.textOverflow ?? 'ellipsis'};
  overflow-wrap: ${(props) => props.overflowWrap};
  white-space: ${(props) => props.whiteSpace ?? 'nowrap'};
  text-align: ${(props) => props.textAlign ?? null};
  flex-grow: ${(props) => `${props.flexGrow}`};
  flex-shrink: ${(props) => `${props.flexShrink}`};
  flex-basis: ${(props) => props.flexBasis};
  align-self: ${(props) => props.alignSelf};

  opacity: ${(props) => props.opacity ?? 1};

  &: hover {
    cursor: ${(props) => (props.onClick ? 'pointer' : undefined)};
    text-decoration: ${(props) => props.hoverEffect};
  }
`;

export const LXh1 = styled(LXh2)`
  font-family: 'Outfit';
  font-style: normal;
  font-weight: ${(props) => props.fontWeight ?? 600};
  font-size: 32px;
  height: ${(props) => props.height ?? '42px'};
  line-height: 38px;
  color: ${(props) => props.color ?? props.theme.colors.title};
`;

export const LXh3 = styled(LXh2)`
  font-family: 'Outfit';
  font-style: normal;
  font-weight: ${(props) => props.fontWeight ?? 600};
  font-size: 18px;
  height: ${(props) => props.height ?? '23px'};
  line-height: 23px;
  color: ${(props) => props.color ?? props.theme.colors.title};
`;

export const LXh4 = styled(LXh2)`
  font-family: 'Outfit';
  font-style: normal;
  font-weight: ${(props) => props.fontWeight ?? 600};
  font-size: 16px;
  height: ${(props) => props.height ?? '21px'};
  line-height: 21px;
  color: ${(props) => props.color ?? props.theme.colors.title};
`;

export const LXh5 = styled(LXh2)`
  font-family: 'Outfit';
  font-style: normal;
  font-weight: ${(props) => props.fontWeight ?? 600};
  font-size: 14px;
  height: ${(props) => props.height ?? '18px'};
  line-height: ${(props) => props.lineHeight ?? '18px'};
  color: ${(props) => props.color ?? props.theme.colors.title};
`;

export const LXbody = styled(LXh2)`
  font-family: 'Outfit';
  font-style: normal;
  height: ${(props) => props.height ?? '18px'};
  font-weight: ${(props) => props.fontWeight ?? 400};
  font-size: 14px;
  line-height: 18px;
  color: ${(props) => props.color ?? props.theme.colors.body};
`;

export const LXbodyLong = styled(LXh2)`
  font-family: 'Outfit';
  font-style: normal;
  font-weight: ${(props) => props.fontWeight ?? 400};
  font-size: ${(props) => props.fontSize ?? '14px'};
  line-height: ${(props) => props.lineHeight ?? `22px`};
  color: ${(props) => props.color ?? props.theme.colors.body};
  white-space: pre-line;

  height: fit-content;
  overflow-wrap: break-word;
`;

export const LXCaption = styled(LXh2)`
  font-family: 'Outfit';
  font-style: normal;
  font-weight: ${(props) => props.fontWeight ?? 400};
  height: ${(props) => props.height ?? '17px'};
  font-size: 13px;
  line-height: 17px;
  color: ${(props) => props.color ?? props.theme.colors.caption};
`;
